export const normalizePhone = (phone: string) => {
  const cleaned = phone.replace(/\D/g, "")
  if (cleaned.length === 11 && cleaned.startsWith("7")) {
    return `+${cleaned}`
  }
  if (cleaned.length === 11 && cleaned.startsWith("8")) {
    return `+7${cleaned.slice(1)}`
  }
  return `+${cleaned}`
}